export const BASE_URL =
  process.env.BASE_URL ||
  "https://qndb0muik4.execute-api.ap-south-1.amazonaws.com/test";
//"http://localhost:3001"

export const GCLIENT_ID =
  process.env.REACT_APP_GCLIENT_ID ||
  "863598619945-lrsn6gqup83ol8k7hti5ort8u4qpdv0n.apps.googleusercontent.com";

export const REDIRECT_URL =
  process.env.REACT_APP_REDIRECT_URL ||
  "";

export const DEFAULT_CLIENT_ID =
  process.env.REACT_APP_DEFAULT_CLIENT_ID ||
  "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";

export const RAZOR_PAY_KEY =
  process.env.REACT_APP_RAZOR_PAY_KEY ||
  "rzp_live_z5lqGyXje3WJSW"
//"rzp_test_tnpNVrJjfVw71n"


export const FIXED_DELIVERY_FEE = 5;
export const SERVICE_CHARGE = 5;

export const ORDER_STATUS: any = {
  "0": "Order Initiated",
  "1": "Order Placed",
  "-1": "Order Failed",
  "2": "Order Delivered",
  "-2": "Refused by Customer",
  "-4": "Cancelled by Admin",
  "5": "Order Approved",
  "-5": "Order Rejected",
  "6": "Order in progress",
  "7": "Picked up from seller",
};


export const processUrl = (url: string) => {
  const s3Domain = "https://hatbazaar.s3.ap-south-1.amazonaws.com";
  // Check if the URL already contains the S3 domain
  if (url?.includes(s3Domain)) {
    return url;
  } else {
    return `${s3Domain}/${url}`;
  }
}